module.exports = __webpack_public_path__ + "media/2.8a6578bc.mp3";